module.exports = "<div class=\"wizard completed\">\n\t<div class=\"wizardHeader\">\n\t\t<h4>{{'ONBOARD_THING.TITLE' | translate}}</h4>\n\t\t<a href=\"\">{{'COMMON.SKIP' | translate}}</a>\n\t</div>\n\t<div class=\"clear\"></div>\n\t<div class=\"wizardChildContainer\">\n\t\t<nuc-wiz-menu-child *ngFor=\"let step of wizSteps\" [title]=\"step.title\" [description]=\"step.description\"\n    [order]=\"step.order\" [activeStep]=\"activeStep\">\n\n    </nuc-wiz-menu-child>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/things/shared/wizard/wiz-menu.component.html
// module id = 1476
// module chunks = 0